import React, { FC } from 'react';
import {
  Container,
  Comment,
  Subtotal,
  DarkText,
  LightText,
  Fragment,
  Avatar,
  Wrap,
} from './styles';
import { Props } from './types';

const Row: FC<Props> = ({ payment, handleOpenModal, ...props }) => {
  return (
    <Container onClick={handleOpenModal} {...props}>
      <Fragment>
        <Subtotal>{payment.subtotal}</Subtotal>
      </Fragment>

      <Fragment>
        <LightText>{payment.tax}</LightText>
      </Fragment>

      <Fragment>
        <LightText>{payment.total}</LightText>
      </Fragment>

      <Fragment>
        <DarkText>{payment.netPayout}</DarkText>
      </Fragment>

      <Wrap>
        <Avatar
          src={payment.brandName.image.src}
          alt={payment.brandName.image.alt}
        />
        <LightText>{payment.brandName.name}</LightText>
      </Wrap>

      <Fragment>
        <Comment>{payment.comments}</Comment>
      </Fragment>
    </Container>
  );
};

export default Row;
